import { SideAreaMap } from "components/Moleculas/Map/Side/SideAreaMap";
import { useCriarManifestacao } from "../contexts/CriarManifestacaoProvider";
import { ComplaintForm } from "./FormManifestacao";

type SideNovaManifestacaoProps = {
  onSuccess: () => void;
};

export function SideNovaManifestacao({ onSuccess }: SideNovaManifestacaoProps) {
  const { latLngSelected, setLatLngSelected, setIsCreating } =
    useCriarManifestacao();

  function onCloseSide() {
    setLatLngSelected(null);
    setIsCreating(false);
  }

  return (
    <SideAreaMap
      isOpen={latLngSelected !== null}
      onClose={onCloseSide}
      zIndex={1000}
    >
      {latLngSelected && (
        <ComplaintForm
          latitude={latLngSelected?.lat}
          longitude={latLngSelected?.lng}
          onSuccess={() => {
            onSuccess();
            onCloseSide();
          }}
        />
      )}
    </SideAreaMap>
  );
}
